/*eslint no-unused-vars: "off"*/
import React from "react";
import { Rate } from 'antd';
import moment from "moment-timezone";
import { formatToCurrency } from "../../../../../Tools/formatToCurrency";

import note from '../../../../../Assets/images/noteico.png';
import chevronDown from '../../../../../Assets/images/chevron-down.png';

// mapping STATUS for hardcoded
const STATUS = {
  draft: 'Draft',
  open: 'Open',
  'open-emailed': 'Open',
  'open-printed': 'Open',
  'overdue': 'Overdue',
  paid: 'Paid',
  void: 'Void',
  closed:'Closed',
  'partially refunded':'Partially Refunded',
  refunded: 'Refunded',
};

// mapping SERVICE_STATUS for hardcoded
const SERVICE_STATUS = {
  forecast: "Forecast",
  scheduled: 'Scheduled',
  incomplete: 'Incomplete',
  complete: 'Complete',
  in_progress: 'In Progress',  
  cancelled: 'Cancelled',
  suspend: 'Suspend'
};

// mapping frequency for hardcoded
const FREQUENCY_MAPPING = {
  weekly: 'Weekly',
  bi_monthly: 'Every Other Week',
  once: 'Just Once',
  twice_weekly: 'Twice Weekly',
  monthly: 'Monthly'
}
const SERVICE_STATUS_COLOR_CLASS = {
  forecast: "gray-status",
  tentative: "info-status",
  paused: "warning-status",
  scheduled: "info-status",
  technician_assigned: "success-status",
  technician_en_route: "success-status",
  in_progress: "success-status",
  complete: "success-status",
  cancelled: "danger-status",
  suspend: "danger-status",
  incomplete: "warning-status"
};
class DataTable {
  Service = () => {
    return [
      {
        title: '',
        dataIndex: 'scheduled_time',
        key: 'scheduled_time',
        sorter: false,
        className: 'tdate',
        render: (text, record) => (          
          <b className="no-wrap">{moment(record?.scheduled_time).format('MMM DD, YYYY')}</b>          )
      },
      {
        title: '',
        dataIndex: 'scheduled_time',
        key: 'scheduled_time',
        sorter: false,
        render: (text, record) => (<strong className="time">{moment(record?.scheduled_time).format('hh:mm A')}</strong>)
      },
      {
        title: '',
        dataIndex: 'frequency',
        key: 'frequency',
        sorter: false,
        render: (text, record) => (<span className="feedback">{record?.frequency ? FREQUENCY_MAPPING[record?.frequency] : '' }</span>)
      },
      {
        title: '',
        dataIndex: 'technician_name',
        key: 'technician_name',
        sorter: false,
        render: (text, record) => (<span className="feedback">{record?.technician_name || ''}</span>)
      },
      {
        title: '',
        dataIndex: 'rating',
        key: 'rating',
        sorter: false,
        render: (text, record) => (<span className="feedback"><Rate allowHalf disabled value={record?.rating}/></span>)
      },
      {
        title: '',
        dataIndex: 'technician_comment',
        key: 'technician_comment',
        sorter: false,
        render: (text, record) => (<span className="note">{record.technician_comment ? record.technician_comment : ''}
          {record.technician_image ? <figure><img src={note} alt=""/></figure> : ''}
        </span>)
      },
      {
        title: '',
        dataIndex: 'status',
        key: 'status',
        sorter: false,
        render: (text, record) => (<span className="status">{record.status ? SERVICE_STATUS[record.status]: ''}</span>)
      }
    ]
  }

  InvoiceWeb = (self) => {
    const invoiceColumns = [
      {
        title: 'Date',
        dataIndex: 'date',
        key: 'date',
        sorter: false,
        className: 'tdate',
        render: (text, record) => (<span className="date"><b>{record?.invoice_date?record?.invoice_date:record?.date_creditmemo}</b></span>)
      },
      {
        title: 'Type',
        dataIndex: 'type',
        key: 'type',
        sorter: false,
        render: (text, record) => (<span className="type">{record?.invoice_date?"Invoice":"Credit Memo"}</span>)
      },
      {
        title: 'Invoice #',
        dataIndex: 'invoice_id',
        key: 'invoice_id',
        sorter: false,
        className: 'tdate',
        render: (text, record) => (<span className="invoice_id">{record?.invoice_id?record?.invoice_id:record?.creditmemo_id}</span>)
      },
      {
        title: 'Due Date',
        dataIndex: 'due_date',
        key: 'due_date',
        sorter: false,
        className:'lfbdr tdate',
        render: (text, record) => (<span className="due_Date">{record.invoice_id?moment(record?.due_date).format('MM/DD/YYYY'):"N/A"}</span>)
      },
      {
        title: 'Balance',
        dataIndex: 'balance',
        key: 'balance',
        sorter: false,
        className: 'tprice',
        render: (text, record) => (record?.status==='draft'?<span className="balance">--</span>:<span className="balance">${record.creditmemo_id && record?.remaining_balance > 0 ? "-" : ""}{record?.balance_due?record?.balance_due:record?.remaining_balance}</span>)
      },
      {
        title: 'Total',
        dataIndex: 'total',
        key: 'total',
        sorter: false,
        className: 'tprice',
        render: (text, record) => (<React.Fragment><span className="totalamt">${record.creditmemo_id && record?.total_with_tax > 0 ? "-" : ""}{record?.total_with_tax}</span></React.Fragment>)
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        className: 'tstatus',
        sorter: false,
        render: (text, record) => (<span className={
          STATUS[record?.status] === 'Overdue' ? 'danger' : STATUS[record?.status] === 'Open' ? 'success' : ''
        }  ><b>{STATUS[record?.status]}</b></span>)
      },
      {
        title: 'Action',
        dataIndex: 'id',
        key: 'id',
        sorter: false,
        className: 'no-wrap',
        render: (text, record) => self.renderAction(record?.uuid, record?.service_order_uuid, record?.status,record,record?.creditmemo_id)
      },
    ]
    return invoiceColumns;
  }
  
   //Payment History
   AllHistoryList = (page) => {
     const historyColumns = [
       {
         title: 'Invoice Number',
         dataIndex: 'invoice',
         key: 'invoice',
         render: (text, record) => (<span className="type ellipse">{record?.invoice_number || ''}</span>)
       },
       {
         title: 'Customer Name',
         dataIndex: 'user',
         key: 'user',
         //  render: (text, record) => (<span className="type ellipse">{text?.first_name} {text?.last_name}</span>)
         render: (text, record) => (<span className="type ellipse">{record?.customer_name?record?.customer_name:"-"}</span>)
       },
       {
         title: 'Amount Received',
         dataIndex: 'amount_received',
         key: 'amount_received',
         render: (text, record) => (<b className="type ellipse">${record?.amount_received ? formatToCurrency(record?.amount_received) : '0.00'}</b>)
       }
       ,
       {
         title: 'Payment Type',
         dataIndex: 'cash_payment',
         key: 'cash_payment',
         render: (text, record) => (<b className="type ellipse">{record?.payment_type?record?.payment_type==="cc" || record?.payment_type==="CC"?record?.payment_type.toUpperCase():record?.payment_type.charAt(0).toUpperCase() + record?.payment_type.slice(1):"-"}</b>)
       },
       {
         title: 'Check Id',
         dataIndex: 'cheque_id',
         key: 'cheque_id',
         render: (text, record) => (<b className="type ellipse">{record?.check_id !== 'None' ? record?.check_id : '-'}</b>)
       },
       {
         title: 'Received From',
         dataIndex: 'received_from',
         key: 'received_from',
         render: (text, record) => (<span className="type ellipse">{record?.received_from?record?.received_from:"-"}</span>)
       },
       {
         title: 'Received By',
         dataIndex: 'received_by',
         key: 'received_by',
         render: (text, record) => (<span className="type ellipse">{record?.received_by?record?.received_by:"-"}</span>)
       },
       {
         title: 'Payment Date',
         dataIndex: 'created_at',
         key: 'created_at',
         render: (text, record) => (<span className="type ellipse">{record?.payment_date ? moment(record?.payment_date).format('MMM DD, YYYY') : 'Check'}</span>)
       },
       {
         title: 'Action',
         dataIndex: 'invoice',
         key: 'action',
         render: (text, record) => 
         {
           return( record?.allow_edit_delete && (record.payment_type !== "CC" && record.payment_type !== "CM") 
           && <div className="position-relative status-dropdown">
             <div className="flex ai-center">
               <span className="status-d-arrow">
                 <img src={chevronDown} alt=""/>
               </span>
             </div>
             <ul className="status-dropdownmenu">
               <li>
                 <a href="#" 
                   onClick={(e) => { 
                     e.preventDefault();
                     page.setState({ show_edit_payment: true, selected_payment: record, edit:true })
                   }}
                 >Edit Payment
                 </a>
               </li>
               <li>
                 <a href="#" 
                   onClick={(e) => { 
                     e.preventDefault();
                     page.setState({show_delete_modal: true, selected_payment: record});
                   }}
                 >Delete Payment
                 </a>
               </li>
             </ul>
           </div>)
         }
       }
     ]
     return historyColumns;
   }

   UpComingWorkOrders = (page) => {
     return [
       {
         title: 'Work Order',
         dataIndex: 'work_order_number',
         key: 'work_order_number',
         sorter: true,
         render: (text, record) => {
           if (record?.work_order_number) {
             return(<>
               <b className="no-wrap" onClick={(e) => { e.preventDefault(); page.setState({currentEditselectedService:record, visible_edit_workOrder: true,workorder_uuid:record?.uuid,transection_type:"View" })}}>
                 {record?.work_order_number ? record?.work_order_number: 'Not created'}
               </b>
               <br />{record?.is_altered && <span className="awo-status mb-5">Altered work order</span>}
               {/* <br />{record?.is_initial_cleaning && <span className="ics-status">Initial clean service</span>} */}
             </>)
           } else {
             return(<>
               <b onClick={(e) => { e.preventDefault(); page.setState({currentEditselectedService:record, visible_edit_workOrder: true,workorder_uuid:record?.uuid,transection_type:"View" })}} className="no-wrap">{record?.work_order_number ? record?.work_order_number: 'Not created'}</b>
               <br />{record?.is_altered && <span className="awo-status mb-5">Altered work order</span>}
               {/* <br />{record?.is_initial_cleaning && <span className="ics-status">Initial clean service</span>} */}
             </>)
           }
         }
       },
       {
         title: 'Date & Time',
         dataIndex: 'scheduled_time',
         key: 'scheduled_time',
         sorter: true,
         render: (text, record) => (
           <b className="no-wrap">{record?.scheduled_time ? moment(record?.scheduled_time).format("MMM DD,YYYY"): ''} {record?.is_time_null!==true?record?.scheduled_time ? moment(record?.scheduled_time).format("hh:mm A"): 'Time not set':'Time not set'}</b>)
       },
       {
         title: 'Service Order',
         dataIndex: 'service_order__service_order_number',
         key: 'service_order_number',
         sorter: true,
         render: (text, record) => (
           <b onClick={(e) => { e.preventDefault(); page.setState({selectedService:record?.service_order },()=>{page.setState({editService:true})})}} className="no-wrap">{record?.service_order?.service_order_number}</b>)
       },
       {
         title: 'Technician',
         dataIndex: 'technician__user__first_name',
         key: 'technician',
         sorter: true,
         render: (text, record) => (
           <b className="no-wrap">{record?.technician ? ` ${record?.technician?.user?.first_name} ${record?.technician?.user?.last_name}` : 'Not assigned'}</b>)
       },
       {
         title: 'Status',
         dataIndex: 'status',
         key: 'status',
         sorter: true,
         render: (text, record) => {
           if (record?.status === 'cancelled' && !record?.bill_for_cancelization) {
             return(
               <div className="status danger-status">
               Cancelled
                 <small>Non Billable</small>
               </div>
             )
           } else if (record?.status === 'cancelled' && record?.bill_for_cancelization && !record?.is_auto_invoice_genrated) {
             return(
               <div className="status danger-status">
               Cancelled
                 <small>Billable</small>
               </div>
             )
           } else if (record?.status === 'cancelled' && record?.is_auto_invoice_genrated) {
             return(
               <div className="status danger-status">
               Cancelled
                 <small>Billed</small>
               </div>
             )
           } else {
             return(
               <span className={record.status ? `status ${SERVICE_STATUS_COLOR_CLASS[record.status]}`: ''}>{record.status ? SERVICE_STATUS[record.status]: ''}</span>
             )
           }
         }
       },
       {
         render: (text, record) => {
           let isInvoiced = false;
           if(record?.is_auto_invoice_genrated===true || record?.is_manual_invoice_generated===true){
             isInvoiced = true;
           }else{
             isInvoiced = false;
           }
           return(<div className="position-relative status-dropdown">
             <div className="flex ai-center">
               <span className="status-d-arrow">
                 <img src={chevronDown} alt=""/>
               </span>
             </div>
             <ul className="status-dropdownmenu">
               {(record?.status !== "cancelled" || record?.status !== "complete") && !isInvoiced &&
               <li><a href="#" onClick={(e) => { e.preventDefault(); page.setState({currentEditselectedService:record, visible_edit_workOrder: true,workorder_uuid:record?.uuid,transection_type:"Edit" })}}>Edit Work Order</a></li>
               }
               <li><a href="#" onClick={(e) => { e.preventDefault();page.setState({currentEditselectedService:record, visible_edit_workOrder: true,workorder_uuid:record?.uuid,transection_type:"View" })}} >View Work Order</a></li>
               {(record?.status !== "cancelled" || record?.status !== "complete") && !isInvoiced && <li><a href="#" onClick={(e) => { e.preventDefault(); page.setState({isDeleteWOModalVisible: true, currentRecord: record})}}>Delete Work Order</a></li>}
             </ul>
           </div>)
         }
       }
     ]
   }

  HistoryWorkOrders = (page) => {
    return [
      {
        title: 'Work Order',
        dataIndex: 'work_order_number',
        key: 'work_order_number',
        sorter: true,
        render: (text, record) => {
          if (record?.work_order_number) {
            return(<>
              <b className="no-wrap" onClick={(e) => { e.preventDefault(); page.setState({currentEditselectedService:record, visible_edit_workOrder: true,workorder_uuid:record?.uuid,transection_type:"View" })}}>
                {record?.work_order_number ? record?.work_order_number: 'Not created'}
              </b>
              <br />{record?.is_altered && <span className="awo-status mb-5">Altered work order</span>}
              {/* <br />{record?.is_initial_cleaning && <span className="ics-status">Initial clean service</span>} */}
            </>)
          } else {
            return(<>
              <b onClick={(e) => { e.preventDefault(); page.setState({currentEditselectedService:record, visible_edit_workOrder: true,workorder_uuid:record?.uuid,transection_type:"View" })}} className="no-wrap">{record?.work_order_number ? record?.work_order_number: 'Not created'}</b>
              <br />{record?.is_altered && <span className="awo-status mb-5">Altered work order</span>}
              {/* <br />{record?.is_initial_cleaning && <span className="ics-status">Initial clean service</span>} */}
            </>)
          }
        }
      },
      {
        title: 'Date & Time',
        dataIndex: 'scheduled_time',
        key: 'scheduled_time',
        sorter: true,
        render: (text, record) => (
          <b className="no-wrap">{record?.scheduled_time ? moment(record?.scheduled_time).format("MMM DD,YYYY"): ''} {record?.is_time_null!==true?record?.scheduled_time ? moment(record?.scheduled_time).format("hh:mm A"): 'Time not set':'Time not set'}</b>)
      },
      {
        title: 'Service Order',
        dataIndex: 'service_order__service_order_number',
        key: 'service_order_number',
        sorter: true,
        render: (text, record) => (
          <b onClick={(e) => { e.preventDefault(); page.setState({selectedService:record?.service_order },()=>{page.setState({editService:true})})}} className="no-wrap">{record?.service_order?.service_order_number}</b>)
      },
      {
        title: 'Technician',
        dataIndex: 'technician__user__first_name',
        key: 'technician',
        sorter: true,
        render: (text, record) => (
          <b className="no-wrap">{record?.technician ? `${record?.technician?.user?.first_name} ${record?.technician?.user?.last_name}` : 'Not assigned'}</b>)

      },
      //  {
      //   title: 'Feedback',
      //   dataIndex: 'technician__user__first_name',
      //   key: 'technician',
      //   render: (text, record) => (
      //     <span className="feedback"><Rate allowHalf disabled value={record.rating} /></span>
      //   )
      //  },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        sorter: true,
        render: (text, record) => {
          if (record?.status === 'cancelled' && !record?.bill_for_cancelization) {
            return(
              <div className="status danger-status">
               Cancelled
                <small>Non Billable</small>
              </div>
            )
          } else if (record?.status === 'cancelled' && record?.bill_for_cancelization && !record?.is_auto_invoice_genrated) {
            return(
              <div className="status danger-status">
               Cancelled
                <small>Billable</small>
              </div>
            )
          } else if (record?.status === 'cancelled' && record?.is_auto_invoice_genrated) {
            return(
              <div className="status danger-status">
               Cancelled
                <small>Billed</small>
              </div>
            )
          } else {
            return(
              <span className={record.status ? `status ${SERVICE_STATUS_COLOR_CLASS[record.status]}`: ''}>{record.status ? SERVICE_STATUS[record.status]: ''}</span>
            )
          }
        }
      },
      {
        render: (text, record) => {
          let isInvoiced = false;
          if(record?.is_auto_invoice_genrated===true || record?.is_manual_invoice_generated===true){
            isInvoiced = true;
          }else{
            isInvoiced = false;
          }
          return(<div className="position-relative status-dropdown">
            <div className="flex ai-center">
              <span className="status-d-arrow">
                <img src={chevronDown} alt=""/>
              </span>
            </div>
            <ul className="status-dropdownmenu">
              {(record?.status !== "cancelled" || record?.status !== "complete") && !isInvoiced &&
               <li><a href="#" onClick={(e) => { e.preventDefault(); page.setState({currentEditselectedService:record, visible_edit_workOrder: true,workorder_uuid:record?.uuid,transection_type:"Edit" })}}>Edit Work Order</a></li>
              }
              <li><a href="#" onClick={(e) => { e.preventDefault();page.setState({currentEditselectedService:record,visible_edit_workOrder: true,workorder_uuid:record?.uuid,transection_type:"View"})}} >View Work Order</a></li>
              {(record?.status !== "cancelled" || record?.status !== "complete") && !isInvoiced && <li><a href="#" onClick={(e) => { e.preventDefault(); page.setState({isDeleteWOModalVisible: true, currentRecord: record})}}>Delete Work Order</a></li>}
            </ul>
          </div>)
        }
      }
    ]
  }

  UpComingWorkOrdersService = (page) => {
    return [
      {
        title: 'Work Order',
        dataIndex: 'work_order_number',
        key: 'work_order_number',
        sorter: true,
        render: (text, record) => {
          if (record?.work_order_number) {
            return(<>
              <b className="no-wrap" onClick={(e) => { e.preventDefault(); page.setState({currentEditselectedService:record, visible_edit_workOrder: true,workorder_uuid:record?.uuid,transection_type:"View" })}}>
                {record?.work_order_number ? record?.work_order_number: 'Not created'}
              </b>
              <br />{record?.is_altered && <span className="awo-status mb-5">Altered work order</span>}
              {/* <br />{record?.is_initial_cleaning && <span className="ics-status">Initial clean service</span>} */}
            </>)
          } else {
            return(<>
              <b onClick={(e) => { e.preventDefault(); page.setState({currentEditselectedService:record, visible_edit_workOrder: true,workorder_uuid:record?.uuid,transection_type:"View" })}} className="no-wrap">{record?.work_order_number ? record?.work_order_number: 'Not created'}</b>
              <br />{record?.is_altered && <span className="awo-status mb-5">Altered work order</span>}
              {/* <br />{record?.is_initial_cleaning && <span className="ics-status">Initial clean service</span>} */}
            </>)
          }
        }
      },
      {
        title: 'Date & Time',
        dataIndex: 'scheduled_time',
        key: 'scheduled_time',
        sorter: true,
        render: (text, record) => (
          <b className="no-wrap">{record?.scheduled_time ? moment(record?.scheduled_time).format("MMM DD,YYYY"): ''} {record?.is_time_null!==true?record?.scheduled_time ? moment(record?.scheduled_time).format("hh:mm A"): 'Time not set':'Time not set'}</b>)
      },
      // {
      //   title: 'Service Order',
      //   dataIndex: 'service_order__service_order_number',
      //   key: 'service_order_number',
      //   sorter: true,
      //   render: (text, record) => (
      //     <b onClick={(e) => { e.preventDefault(); page.setState({selectedService:record?.service_order },()=>{page.setState({editService:true})})}} className="no-wrap">{record?.service_order?.service_order_number}</b>)
      // },
      {
        title: 'Technician',
        dataIndex: 'technician__user__first_name',
        key: 'technician',
        sorter: true,
        render: (text, record) => (
          <b className="no-wrap">{record?.technician ? ` ${record?.technician?.user?.first_name} ${record?.technician?.user?.last_name}` : 'Not assigned'}</b>)
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        sorter: true,
        render: (text, record) => {
          if (record?.status === 'cancelled' && !record?.bill_for_cancelization) {
            return(
              <div className="status danger-status">
              Cancelled
                <small>Non Billable</small>
              </div>
            )
          } else if (record?.status === 'cancelled' && record?.bill_for_cancelization && !record?.is_auto_invoice_genrated) {
            return(
              <div className="status danger-status">
              Cancelled
                <small>Billable</small>
              </div>
            )
          } else if (record?.status === 'cancelled' && record?.is_auto_invoice_genrated) {
            return(
              <div className="status danger-status">
              Cancelled
                <small>Billed</small>
              </div>
            )
          } else {
            return(
              <span className={record.status ? `status ${SERVICE_STATUS_COLOR_CLASS[record.status]}`: ''}>{record.status ? SERVICE_STATUS[record.status]: ''}</span>
            )
          }
        }
      },
      {
        render: (text, record) => {
          let isInvoiced = false;
          if(record?.is_auto_invoice_genrated===true || record?.is_manual_invoice_generated===true){
            isInvoiced = true;
          }else{
            isInvoiced = false;
          }
          return(<div className="position-relative status-dropdown">
            <div className="flex ai-center">
              <span className="status-d-arrow">
                <img src={chevronDown} alt=""/>
              </span>
            </div>
            <ul className="status-dropdownmenu">
              {(record?.status !== "cancelled" || record?.status !== "complete") && !isInvoiced &&
              <li><a href="#" onClick={(e) => { e.preventDefault(); page.setState({currentEditselectedService:record, visible_edit_workOrder: true,workorder_uuid:record?.uuid,transection_type:"Edit" })}}>Edit Work Order</a></li>
              }
              <li><a href="#" onClick={(e) => { e.preventDefault();page.setState({currentEditselectedService:record, visible_edit_workOrder: true,workorder_uuid:record?.uuid,transection_type:"View" })}} >View Work Order</a></li>
              {(record?.status !== "cancelled" || record?.status !== "complete") && !isInvoiced && <li><a href="#" onClick={(e) => { e.preventDefault(); page.setState({isDeleteWOModalVisible: true, currentRecord: record})}}>Delete Work Order</a></li>}
            </ul>
          </div>)
        }
      }
    ]
  }

 HistoryWorkOrdersService = (page) => {
   return [
     {
       title: 'Work Order',
       dataIndex: 'work_order_number',
       key: 'work_order_number',
       sorter: true,
       render: (text, record) => {
         if (record?.work_order_number) {
           return(<>
             <b className="no-wrap" onClick={(e) => { e.preventDefault(); page.setState({currentEditselectedService:record, visible_edit_workOrder: true,workorder_uuid:record?.uuid,transection_type:"View" })}}>
               {record?.work_order_number ? record?.work_order_number: 'Not created'}
             </b>
             <br />{record?.is_altered && <span className="awo-status mb-5">Altered work order</span>}
             {/* <br />{record?.is_initial_cleaning && <span className="ics-status">Initial clean service</span>} */}
           </>)
         } else {
           return(<>
             <b onClick={(e) => { e.preventDefault(); page.setState({currentEditselectedService:record, visible_edit_workOrder: true,workorder_uuid:record?.uuid,transection_type:"View" })}} className="no-wrap">{record?.work_order_number ? record?.work_order_number: 'Not created'}</b>
             <br />{record?.is_altered && <span className="awo-status mb-5">Altered work order</span>}
             {/* <br />{record?.is_initial_cleaning && <span className="ics-status">Initial clean service</span>} */}
           </>)
         }
       }
     },
     {
       title: 'Date & Time',
       dataIndex: 'scheduled_time',
       key: 'scheduled_time',
       sorter: true,
       render: (text, record) => (
         <b className="no-wrap">{record?.scheduled_time ? moment(record?.scheduled_time).format("MMM DD,YYYY"): ''} {record?.is_time_null!==true?record?.scheduled_time ? moment(record?.scheduled_time).format("hh:mm A"): 'Time not set':'Time not set'}</b>)
     },
     //  {
     //    title: 'Service Order',
     //    dataIndex: 'service_order__service_order_number',
     //    key: 'service_order_number',
     //    sorter: true,
     //    render: (text, record) => (
     //      <b className="no-wrap">{record?.service_order?.service_order_number}</b>)
     //  },
     {
       title: 'Technician',
       dataIndex: 'technician__user__first_name',
       key: 'technician',
       sorter: true,
       render: (text, record) => (
         <b className="no-wrap">{record?.technician ? `${record?.technician?.user?.first_name} ${record?.technician?.user?.last_name}` : 'Not assigned'}</b>)

     },
     //  {
     //   title: 'Feedback',
     //   dataIndex: 'technician__user__first_name',
     //   key: 'technician',
     //   render: (text, record) => (
     //     <span className="feedback"><Rate allowHalf disabled value={record.rating} /></span>
     //   )
     //  },
     {
       title: 'Status',
       dataIndex: 'status',
       key: 'status',
       sorter: true,
       render: (text, record) => {
         if (record?.status === 'cancelled' && !record?.bill_for_cancelization) {
           return(
             <div className="status danger-status">
              Cancelled
               <small>Non Billable</small>
             </div>
           )
         } else if (record?.status === 'cancelled' && record?.bill_for_cancelization && !record?.is_auto_invoice_genrated) {
           return(
             <div className="status danger-status">
              Cancelled
               <small>Billable</small>
             </div>
           )
         } else if (record?.status === 'cancelled' && record?.is_auto_invoice_genrated) {
           return(
             <div className="status danger-status">
              Cancelled
               <small>Billed</small>
             </div>
           )
         } else {
           return(
             <span className={record.status ? `status ${SERVICE_STATUS_COLOR_CLASS[record.status]}`: ''}>{record.status ? SERVICE_STATUS[record.status]: ''}</span>
           )
         }
       }
     },
     {
       render: (text, record) => {
         let isInvoiced = false;
         if(record?.is_auto_invoice_genrated===true || record?.is_manual_invoice_generated===true){
           isInvoiced = true;
         }else{
           isInvoiced = false;
         }
         return(<div className="position-relative status-dropdown">
           <div className="flex ai-center">
             <span className="status-d-arrow">
               <img src={chevronDown} alt=""/>
             </span>
           </div>
           <ul className="status-dropdownmenu">
             {(record?.status !== "cancelled" || record?.status !== "complete") && !isInvoiced &&
              <li><a href="#" onClick={(e) => { e.preventDefault(); page.setState({currentEditselectedService:record, visible_edit_workOrder: true,workorder_uuid:record?.uuid,transection_type:"Edit" })}}>Edit Work Order</a></li>
             }
             <li><a href="#" onClick={(e) => { e.preventDefault();page.setState({currentEditselectedService:record,visible_edit_workOrder: true,workorder_uuid:record?.uuid,transection_type:"View"})}} >View Work Order</a></li>
             {(record?.status !== "cancelled" || record?.status !== "complete") && !isInvoiced && <li><a href="#" onClick={(e) => { e.preventDefault(); page.setState({isDeleteWOModalVisible: true, currentRecord: record})}}>Delete Work Order</a></li>}
           </ul>
         </div>)
       }
     }
   ]
 }

 UpComingWorkOrdersProduct = (page) => {
   return [
     {
       title: 'Work Order',
       dataIndex: 'work_order_number',
       key: 'work_order_number',
       sorter: true,
       render: (text, record) => {
         if (record?.work_order_number) {
           return(<>
             <b className="no-wrap" onClick={(e) => { e.preventDefault(); page.setState({currentEditselectedService:record, visible_edit_workOrder: true,workorder_uuid:record?.uuid,transection_type:"View" })}}>
               {record?.work_order_number ? record?.work_order_number: 'Not created'}
             </b>
             <br />{record?.is_altered && <span className="awo-status mb-5">Altered work order</span>}
             {/* <br />{record?.is_initial_cleaning && <span className="ics-status">Initial clean service</span>} */}
           </>)
         } else {
           return(<>
             <b onClick={(e) => { e.preventDefault(); page.setState({currentEditselectedService:record, visible_edit_workOrder: true,workorder_uuid:record?.uuid,transection_type:"View" })}} className="no-wrap">{record?.work_order_number ? record?.work_order_number: 'Not created'}</b>
             <br />{record?.is_altered && <span className="awo-status mb-5">Altered work order</span>}
             {/* <br />{record?.is_initial_cleaning && <span className="ics-status">Initial clean service</span>} */}
           </>)
         }
       }
     },
     {
       title: 'Date & Time',
       dataIndex: 'scheduled_time',
       key: 'scheduled_time',
       sorter: true,
       render: (text, record) => (
         <b className="no-wrap">{record?.scheduled_time ? moment(record?.scheduled_time).format("MMM DD,YYYY"): ''} {record?.is_time_null!==true?record?.scheduled_time ? moment(record?.scheduled_time).format("hh:mm A"): 'Time not set':'Time not set'}</b>)
     },
     // {
     //   title: 'Service Order',
     //   dataIndex: 'service_order__service_order_number',
     //   key: 'service_order_number',
     //   sorter: true,
     //   render: (text, record) => (
     //     <b onClick={(e) => { e.preventDefault(); page.setState({selectedService:record?.service_order },()=>{page.setState({editService:true})})}} className="no-wrap">{record?.service_order?.service_order_number}</b>)
     // },
     // {
     //   title: 'Technician',
     //   dataIndex: 'technician__user__first_name',
     //   key: 'technician',
     //   sorter: true,
     //   render: (text, record) => (
     //     <b className="no-wrap">{record?.technician ? `${record?.technician?.user?.last_name} ${record?.technician?.user?.first_name}` : 'Not assigned'}</b>)
     // },
     {
       title: 'Status',
       dataIndex: 'status',
       key: 'status',
       sorter: true,
       render: (text, record) => {
         if (record?.status === 'cancelled' && !record?.bill_for_cancelization) {
           return(
             <div className="status danger-status">
            Cancelled
               <small>Non Billable</small>
             </div>
           )
         } else if (record?.status === 'cancelled' && record?.bill_for_cancelization && !record?.is_auto_invoice_genrated) {
           return(
             <div className="status danger-status">
            Cancelled
               <small>Billable</small>
             </div>
           )
         } else if (record?.status === 'cancelled' && record?.is_auto_invoice_genrated) {
           return(
             <div className="status danger-status">
            Cancelled
               <small>Billed</small>
             </div>
           )
         } else {
           return(
             <span className={record.status ? `status ${SERVICE_STATUS_COLOR_CLASS[record.status]}`: ''}>{record.status ? SERVICE_STATUS[record.status]: ''}</span>
           )
         }
       }
     },
     {
       render: (text, record) => {
         let isInvoiced = false;
         if(record?.is_auto_invoice_genrated===true || record?.is_manual_invoice_generated===true){
           isInvoiced = true;
         }else{
           isInvoiced = false;
         }
         return(<div className="position-relative status-dropdown">
           <div className="flex ai-center">
             <span className="status-d-arrow">
               <img src={chevronDown} alt=""/>
             </span>
           </div>
           <ul className="status-dropdownmenu">
             {(record?.status !== "cancelled" || record?.status !== "complete") && !isInvoiced &&
            <li><a href="#" onClick={(e) => { e.preventDefault(); page.setState({currentEditselectedService:record, visible_edit_workOrder: true,workorder_uuid:record?.uuid,transection_type:"Edit" })}}>Edit Work Order</a></li>
             }
             <li><a href="#" onClick={(e) => { e.preventDefault();page.setState({currentEditselectedService:record, visible_edit_workOrder: true,workorder_uuid:record?.uuid,transection_type:"View" })}} >View Work Order</a></li>
             {(record?.status !== "cancelled" || record?.status !== "complete") && !isInvoiced && <li><a href="#" onClick={(e) => { e.preventDefault(); page.setState({isDeleteWOModalVisible: true, currentRecord: record})}}>Delete Work Order</a></li>}
           </ul>
         </div>)
       }
     }
   ]
 }

HistoryWorkOrdersProduct = (page) => {
  return [
    {
      title: 'Work Order',
      dataIndex: 'work_order_number',
      key: 'work_order_number',
      sorter: true,
      render: (text, record) => {
        if (record?.work_order_number) {
          return(<>
            <b className="no-wrap" onClick={(e) => { e.preventDefault(); page.setState({currentEditselectedService:record, visible_edit_workOrder: true,workorder_uuid:record?.uuid,transection_type:"View" })}}>
              {record?.work_order_number ? record?.work_order_number: 'Not created'}
            </b>
            <br />{record?.is_altered && <span className="awo-status mb-5">Altered work order</span>}
            {/* <br />{record?.is_initial_cleaning && <span className="ics-status">Initial clean service</span>} */}
          </>)
        } else {
          return(<>
            <b onClick={(e) => { e.preventDefault(); page.setState({currentEditselectedService:record, visible_edit_workOrder: true,workorder_uuid:record?.uuid,transection_type:"View" })}} className="no-wrap">{record?.work_order_number ? record?.work_order_number: 'Not created'}</b>
            <br />{record?.is_altered && <span className="awo-status mb-5">Altered work order</span>}
            {/* <br />{record?.is_initial_cleaning && <span className="ics-status">Initial clean service</span>} */}
          </>)
        }
      }
    },
    {
      title: 'Date & Time',
      dataIndex: 'scheduled_time',
      key: 'scheduled_time',
      sorter: true,
      render: (text, record) => (
        <b className="no-wrap">{record?.scheduled_time ? moment(record?.scheduled_time).format("MMM DD,YYYY"): ''} {record?.is_time_null!==true?record?.scheduled_time ? moment(record?.scheduled_time).format("hh:mm A"): 'Time not set':'Time not set'}</b>)
    },
    //  {
    //    title: 'Service Order',
    //    dataIndex: 'service_order__service_order_number',
    //    key: 'service_order_number',
    //    sorter: true,
    //    render: (text, record) => (
    //      <b className="no-wrap">{record?.service_order?.service_order_number}</b>)
    //  },
    //  {
    //    title: 'Technician',
    //    dataIndex: 'technician__user__first_name',
    //    key: 'technician',
    //    sorter: true,
    //    render: (text, record) => (
    //      <b className="no-wrap">{record?.technician ? `${record?.technician?.user?.last_name} ${record?.technician?.user?.first_name} ` : 'Not assigned'}</b>)

    //  },
    //  {
    //   title: 'Feedback',
    //   dataIndex: 'technician__user__first_name',
    //   key: 'technician',
    //   render: (text, record) => (
    //     <span className="feedback"><Rate allowHalf disabled value={record.rating} /></span>
    //   )
    //  },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      sorter: true,
      render: (text, record) => {
        if (record?.status === 'cancelled' && !record?.bill_for_cancelization) {
          return(
            <div className="status danger-status">
            Cancelled
              <small>Non Billable</small>
            </div>
          )
        } else if (record?.status === 'cancelled' && record?.bill_for_cancelization && !record?.is_auto_invoice_genrated) {
          return(
            <div className="status danger-status">
            Cancelled
              <small>Billable</small>
            </div>
          )
        } else if (record?.status === 'cancelled' && record?.is_auto_invoice_genrated) {
          return(
            <div className="status danger-status">
            Cancelled
              <small>Billed</small>
            </div>
          )
        } else {
          return(
            <span className={record.status ? `status ${SERVICE_STATUS_COLOR_CLASS[record.status]}`: ''}>{record.status ? SERVICE_STATUS[record.status]: ''}</span>
          )
        }
      }
    },
    {
      render: (text, record) => {
        let isInvoiced = false;
        if(record?.is_auto_invoice_genrated===true || record?.is_manual_invoice_generated===true){
          isInvoiced = true;
        }else{
          isInvoiced = false;
        }
        return(<div className="position-relative status-dropdown">
          <div className="flex ai-center">
            <span className="status-d-arrow">
              <img src={chevronDown} alt=""/>
            </span>
          </div>
          <ul className="status-dropdownmenu">
            {(record?.status !== "cancelled" || record?.status !== "complete") && !isInvoiced &&
            <li><a href="#" onClick={(e) => { e.preventDefault(); page.setState({currentEditselectedService:record, visible_edit_workOrder: true,workorder_uuid:record?.uuid,transection_type:"Edit" })}}>Edit Work Order</a></li>
            }
            <li><a href="#" onClick={(e) => { e.preventDefault();page.setState({currentEditselectedService:record,visible_edit_workOrder: true,workorder_uuid:record?.uuid,transection_type:"View"})}} >View Work Order</a></li>
            {(record?.status !== "cancelled" || record?.status !== "complete") && !isInvoiced && <li><a href="#" onClick={(e) => { e.preventDefault(); page.setState({isDeleteWOModalVisible: true, currentRecord: record})}}>Delete Work Order</a></li>}
          </ul>
        </div>)
      }
    }
  ]
}
}

export default new DataTable()
